import { Enums } from '@cyborg-monorepo/hunter/common'
import { BadgeVariant } from '@hyperkit'

export function getPriorityVariant(priority: Enums.PriorityEnum): BadgeVariant {
  switch (priority) {
    case Enums.PriorityEnum.LOW:
      return 'success'
    case Enums.PriorityEnum.MEDIUM:
      return 'warning'
    case Enums.PriorityEnum.HIGH:
      return 'error'
    default:
      return 'neutral'
  }
}

export function getStatusVariant(status: Enums.StatusEnum): BadgeVariant {
  switch (status) {
    case Enums.StatusEnum.TO_DO:
      return 'warning'
    case Enums.StatusEnum.IN_PROGRESS:
      return 'information'
    case Enums.StatusEnum.DONE:
      return 'success'
    default:
      return 'neutral'
  }
}

export function getOutcomeVariant(
  outcome: Enums.OutcomeEnum | null,
): BadgeVariant {
  switch (outcome) {
    case Enums.OutcomeEnum.NO_FINDINGS:
      return 'success'
    case Enums.OutcomeEnum.VISIBILITY_GAP:
      return 'warning'
    case Enums.OutcomeEnum.DETECTION:
      return 'information'
    case Enums.OutcomeEnum.ESCALATED:
      return 'error'
    default:
      return 'neutral'
  }
}

export function getSeverityBadgeVariant(severity: string): BadgeVariant {
  switch (severity) {
    case Enums.SeverityEnum.LOW:
      return 'success'
    case Enums.SeverityEnum.MEDIUM:
      return 'warning'
    case Enums.SeverityEnum.HIGH:
    case Enums.SeverityEnum.CRITICAL:
      return 'error'
    default:
      return 'neutral'
  }
}

export const outcomeMap = new Map<Enums.OutcomeEnum, string>([
  [Enums.OutcomeEnum.DETECTION, 'Suggested Detection'],
  [Enums.OutcomeEnum.NO_FINDINGS, 'Hunt Methodology'],
  [Enums.OutcomeEnum.ESCALATED, 'Escalation Details'],
  [
    Enums.OutcomeEnum.VISIBILITY_GAP,
    'Hunt Limitations/Visibility Improvements',
  ],
])
